import { useContext, useEffect, useRef, useState } from "react";
import ToastContext from "../../../../src/contexts/toast";
import { PagamentoService } from "../../../services/PagamentoService";
import Upload from "../../Form/Upload";
import { FormUtility } from "../../Utility/FormUtility";
import moment from "moment";

export default function GestionePagamenti() {
  console.log("inside gestione pagamenti");

  const toastContext = useContext(ToastContext);
  const pagamentoService = new PagamentoService();
  const utility = new FormUtility();

  const [disabledConfirmBtn, setDisabledConfirmBtn] = useState(true);
  const [validazioneVisible, setValidazioneVisible] = useState(false);
  const [validazioneClass, setValidazioneClass] = useState(null);
  const [validazioneIcon, setValidazioneIcon] = useState(null);
  const [file, setFile] = useState(null);
  const [validazioneOk, setValidazioneOk] = useState(false);
  const [validazioneLabel, setValidazioneLabel] = useState(null);
  const [esitoImportazione, setEsitoImportazione] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [latestImportDate, setLatestImportDate] = useState(null);

  const uploadRef = useRef(null);

  

  useEffect(() => {
    fetchLatestImportDate();
  }, []);

  const validExtensions = ["csv"];

  const updateReportAndStatus = (data, isImportOperation = false) => {
    const success = data && data.ok;

    setValidazioneOk(success);

    if (isImportOperation) {
        setEsitoImportazione(true);
        setFile(null);
    } else {
        setEsitoImportazione(false);
        setFile(success ? data.file : null);
    }

    setValidazioneClass(success ? "rtds-text-success-dark" : "rtds-text-error-dark");
    setValidazioneIcon(success ? "icons.svg#solid--check" : "icons.svg#solid--x-mark");

    let mappedData;
    if (success) {
        mappedData = [
            { number: data.righeImportateConSuccesso, message: isImportOperation ? "pagamenti importati" : "pagamenti che verranno importati" },
            { number: data.righeAggiornate, message: isImportOperation ? "record aggiornati" : "record che verranno aggiornati"},
            { number: data.righeCreate, message: isImportOperation ? "record aggiunti" : "record che verranno aggiunti" },
            { number: data.righeOk, message: "esiti OK" },
            { number: data.righeKo, message: "esiti KO" }
        ];
    } else {
        mappedData = data.erroriValidazione ? data.erroriValidazione.flat().map((error) => {
            return {
                number: "",
                message: error,
            };
        }) : [{ number: "", message: "Nessun dettaglio errore disponibile." }];
    }
    setReportData(mappedData);

    if (success) {
        if (isImportOperation) {
            toastContext.success("Importazione completata con successo!");
        }
    } else {
        if (isImportOperation) {
            toastContext.error("Importazione fallita. Controlla i dettagli.");
        } else {
            toastContext.warning("Validazione fallita. Controlla gli errori.");
        }
    }

    setValidazioneVisible(true);
    setDisabledConfirmBtn(!success);
  };

  const onFileChanged = async () => {
    setDisabledConfirmBtn(true);
    setValidazioneVisible(false);
    setValidazioneOk(false);
    setEsitoImportazione(false);
    setFile(null);
    setReportData(null);
  };

  const onUploadOk = async () => {

  };

  const onValidationDone = async (data, selectedFile) => {
    setValidazioneLabel("Validazione del file CSV");
    updateReportAndStatus(data, false);
    setFile(selectedFile);
  };

  const onImportDone = async (data) => {
    uploadRef.current.reset();
    setValidazioneLabel("Risultato importazione");
    updateReportAndStatus(data, true);
  };

  const validaFile = async (fileToValidate) => {
    try {
      const response = await pagamentoService.valida(fileToValidate);
      return response;
    } catch (error) {
      console.error("Errore durante la validazione del file:", error);
      toastContext.error("Si è verificato un errore durante la validazione del file.");
      return { ok: false, erroriValidazione: ["Errore di comunicazione con il server durante la validazione."] };
    }
  };

  const importaFile = async () => {
    if (!file) {
      toastContext.warning("Nessun file da importare. Esegui prima la validazione.");
      return;
    }
    try {
      const response = await pagamentoService.importa(file);
      onImportDone(response);
    } catch (error) {
      console.error("Errore durante l'importazione del file:", error);
      toastContext.error("Si è verificato un errore imprevisto durante l'importazione.");
      onImportDone({ ok: false, erroriValidazione: ["Errore di comunicazione con il server durante l'importazione."] });
    }
  };

  const fetchLatestImportDate = async () => {
    const response = await pagamentoService.getUltimaImportazione();
    if(response.data){
      const formattedDate = moment(response.data).format('DD/MM/YYYY');
      setLatestImportDate(formattedDate);
    }else
      setLatestImportDate(null);
  }

  return (
    <>
      <div className="rtds-container rtds-py-6">
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          <div className="rtds-flex rtds-items-center rtds-justify-between">
            <h1 className="rtds-heading-2">Gestione pagamenti</h1>
          </div>
          {latestImportDate && (
              <p className="rtds-text-base rtds-text-gray-06">
                Ultima importazione: <span className="rtds-font-semibold">{latestImportDate}</span>
              </p>
            )}
          <Upload
            ref={uploadRef}
            id={"fileExcel"}
            onFileChanged={onFileChanged}
            onUploadOk={onUploadOk}
            onValidationDone={onValidationDone}
            validExtensions={validExtensions}
            funzioneValidazioneEsterna={validaFile}
            caricaVisible={true}
            label={"Importa pagamenti"}
          />
          
          {validazioneVisible && (
            <div className="rtds-p-3 rtds-border rtds-rounded rtds-border-gray-02">
              <h3 id="validazioneExcel" className="rtds-heading-6 rtds-mb-3">
                {validazioneLabel}
              </h3>
              <ul
                className="scrollable-list "
                aria-labelledby="validazioneExcel"
              >
                {reportData &&
                  reportData.map((item, index) => (
                    <li
                      key={index}
                      className="rtds-mb-2 rtds-aling-center rtds-flex "
                    >
                      <svg
                        className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${validazioneClass}`}
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/${validazioneIcon}`}
                        />
                      </svg>
                      {validazioneClass.includes("error") && item.number && (
                        <>&nbsp;&nbsp;Alla riga:</>
                      )}
                      &nbsp;
                      <span className="rtds-content-info">{item.number}</span>
                      &nbsp;{item.message}
                    </li>
                  ))}
              </ul>

              <button
                type="button"
                className="rtds-btn--primary rtds-btn rtds-btn--icon-right rtds-group/button"
                disabled={esitoImportazione || !validazioneOk}
                hidden={esitoImportazione || !validazioneOk}
                onClick={importaFile}
              >
                
                Importa
                <svg className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1" aria-hidden="true" focusable="false" role="img">
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}